import { createSlice } from '@reduxjs/toolkit'
import { useCookies } from 'react-cookie'


export const changePasswordSlice = createSlice({
  name: 'changePassword',
  initialState: {
    oldPassword: '',
    newPassword: '',
    confirmPassword:'',
    loading:false,
    alertText:false,
    feedback:{
        message: '',
        color: '',
        display: false
      } 
  },
  reducers: {
    setOldPasswordRedux: (state, action) => {
      const { oldPassword } = action.payload
      state.oldPassword = oldPassword
    },
    setNewPasswordRedux: (state, action) => {
        const { newPassword } = action.payload
        state.newPassword = newPassword
      },
      setConfirmPasswordRedux: (state, action) => {
        const { confirmPassword } = action.payload
        state.confirmPassword = confirmPassword
      },
      setLoadingRedux: (state, action) => {
        const { loading } = action.payload
        state.loading = loading
      },
      setAlertTextRedux: (state, action) => {
        const { alertText } = action.payload
        state.alertText = alertText
      },
      setFeedbackRedux: (state, action) => {
        const { feedback } = action.payload
        state.feedback = feedback
      },
      
  },
})

export default changePasswordSlice.reducer;

export const {
    setOldPasswordRedux,
    setNewPasswordRedux,
    setConfirmPasswordRedux,
    setLoadingRedux,
    setAlertTextRedux,
    setFeedbackRedux
  
} = changePasswordSlice.actions

export const getOldPasswordRedux = (state) => state.changePassword.oldPassword
export const getNewPasswordRedux = (state) => state.changePassword.newPassword
export const getConfirmPasswordRedux = (state) => state.changePassword.confirmPassword
export const getLoadingRedux = (state) => state.changePassword.loading
export const getAlertTextRedux = (state) => state.changePassword.alertText
export const getFeedbackRedux = (state) => state.changePassword.feedback



